import { render, staticRenderFns } from "./EditSessionDialog.vue?vue&type=template&id=1b070ded&"
import script from "./EditSessionDialog.vue?vue&type=script&lang=js&"
export * from "./EditSessionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports